import { render, staticRenderFns } from "./IndexSeven.vue?vue&type=template&id=60757bcb"
import script from "./IndexSeven.vue?vue&type=script&lang=js"
export * from "./IndexSeven.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports